import { useContext } from 'react';
import { ToastContext } from './toast-provider';

export const useToast = () => {
  return useContext(ToastContext);
};
